
import { useState, useEffect, useContext } from 'react'

import { GlobalContext, HOST } from "./context/GlobalContext"

import Menu from './Menu'
import SectionTitle from './SectionTitle'
import DashBoard from './DashBoard'
import Proveedores from './Provedores'
import Editorial from './Editorial'
import Almacen from './Almacen'
import Compras from './Compras'
import Remisiones from './Remisiones'
import Libreria from './Libreria'
import Devoluciones from './Devoluciones'
import Clientes from './Clientes'
import Ventas from './Ventas'
import Reportes from './Reportes'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'
import './Loading.css'

function Home() {
  const [ section, setSection ] = useState( 'dashboard' )

  const { globalLoading, setLogged, setUserName, setRol, setName } = useContext(GlobalContext);

  useEffect(() => {
    var login = sessionStorage.getItem('lji_auth')

    if( login ) {
      setUserName( sessionStorage.getItem('lji_auth') )
      setName( sessionStorage.getItem('lji_name') )
      setRol( sessionStorage.getItem('lji_rol') )
      setLogged( true )
    } else {
      setLogged( false )
    }
  }, []); 
  
  const handleSelectSection = sect => {
    setSection(current => sect);

    console.log('argument from Child: ', sect);
  };

  return (
    <div className='body-container'>
      <div className={ globalLoading ? 'lmask' : 'hide' }></div>

      <Container className='main-container'>
        <Row>
          <Col className='col-menu-left'>
            <div className="menu-left">
              <Menu handleSelectSection={ handleSelectSection } section={ section }/>
            </div>
          </Col>

          <Col className="menu-right">

            <Container>
              <Row>
                <Col>
                  <SectionTitle section={ section }/>
                </Col>
              </Row>
            </Container>
            <br/>

            <Container>
              <Row>
                <Col>
                  { section === 'dashboard' &&
                    <DashBoard />
                  }
                  { section === 'proveedores' &&
                    <Proveedores />
                  }
                  { section === 'editoriales' &&
                    <Editorial />
                  }
                  { section === 'almacenes' &&
                    <Almacen />
                  }
                  { section === 'sales' &&
                    <Ventas />
                  }

                  { section === 'shopping' &&
                    <Compras />
                  }
                  { section === 'remision' &&
                    <Remisiones />
                  }
                  { section === 'library' &&
                    <Libreria />
                  }
                  { section === 'return' &&
                    <Devoluciones />
                  }
                  { section === 'clientes' &&
                    <Clientes />
                  }
                  { section === 'reportes' &&
                    <Reportes />
                  }
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Home;
